import { render, staticRenderFns } from "./additional-info-modal.vue?vue&type=template&id=04e6ba57"
import script from "./additional-info-modal.vue?vue&type=script&lang=js"
export * from "./additional-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports